import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import ExcludeUnknownUrl from './ExcludeUnknownUrl';

const mapStateToProps = (state: any) => ({
  settings: state.trackerSettings.global.settings,
  isLoading: state.trackerSettings.global.isLoading,
  failed: state.trackerSettings.global.failed,
});

export const ConnectedExcludeUnknownUrl = connect(
  mapStateToProps, null,
)(ExcludeUnknownUrl);

export default withTranslation(['administration'])(ConnectedExcludeUnknownUrl as any);
